import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row, Image } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { NewSelectBoxInput } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  getCityFromCountry,
  getRestaurantByCityName,
} from "../../../../../store/actions/SuperAdminActions/adminManageOffers";

import { addIssuesSuggestionAdmin } from "../../../../../store/actions/SuperAdminActions/commonSuperAdmin";
import SimpleReactLightbox from "simple-react-lightbox";
import { MultipleImageUploadComponent } from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import { resizeFile60 } from "../../../../reusableComponents/imageUploadReusableComponent/ImageResizerComponent";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { InputCharacterCheck } from "../../../../../function/InputCharNumCheckFunc";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import { imageUploadSize } from "../../../../../config/Keys";
import Alert from "react-s-alert";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import axios from "axios";
import { getInfoVendorByMobile } from "../../../../../store/actions/needHelpAction/needHelpAction";
import { serverApi } from "../../../../../config/Keys";
import Resizer from "react-image-file-resizer";
import isEmpty from "../../../../../store/validation/is-Empty";

const validationSchema = yup.object({
  type: yup.string().required("Please select Issue Type"),
  title: yup
    .string()
    .required("Title is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  description: yup
    .string()
    .required("Description is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  categoryId: yup.string().required("Please select category"),
});

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const AddOpenIssuesVendor = (props) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  //state
  const [file, setFile] = useState(null);
  const [state, setState] = useState({
    category: "",
    country_code: "",
    mobile: "",
    country: "",
    restaurant: "",
    state: "",
    City: "",
    actionButton: false,
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    combined: "",
    progress: 0,
    thumbnail: true,
    thumbnailImages: [],
  });

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const onCompleteUploadMultipleCrop = (e) => {
    let oldData = state.restaurant_pictures;
    oldData.push(e);
    if (state.thumbnail) {
      let thumbData = state.thumbnailImages;
      let url = e.split("/");
      url.splice(url.length - 1, 0, "thumbnail");
      url = url.join("/");
      thumbData.push(url);
      setState({
        ...state,
        thumbnailImages: thumbData,
      });
    }
    setState({
      ...state,
      restaurant_pictures: oldData,
      actionButton: true,
    });
  };

  const cancelFiles = (file) => {
    let restaurant_pictures_temp = state.restaurant_pictures_new;
    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setState({ ...state, restaurant_pictures_new: newToUpload });
  };

  const uploadMultipleFiles = (e) => {
    const vendor_id = props.auth.user.VendorUser._id;
    const restaurant_name = props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    var newUploaded = [];
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > imageUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else if (e.target.files.length > 5) {
        alert("You can upload only 10 files");
        return (flag = false);
      } else {
        let allPictures = state.restaurant_pictures;
        allPictures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            // flag = true;
            return (flag = true);
          } else {
            return (flag = false);
          }
        });
        if (!flag) {
          newUploaded.push(e.target.files[i]);
          data.append("files", e.target.files[i]);
        }
      }
    }
    if (!flag) {
      setState({
        ...state,
        restaurant_pictures_new: newUploaded,
        combined: combined,
      });
    } else {
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    // e.target.value = "";
  };

  const multipleResetFile = (indexId) => {
    let allPictures = state.restaurant_pictures;
    let allPicturesObj = allPictures.find((images, index) => index === indexId);
    if (allPicturesObj === 0 || allPicturesObj) {
      allPictures.splice(allPictures.indexOf(allPicturesObj), 1);
      setState({ ...state, allPictures: allPictures, actionButton: true });
    }
  };
  const [vendor, setVendor] = useState({});
  const handleChangeCategoryAdd = (event) => {
    setState({
      ...state,
      category: event.target.value,
    });
    formik.setFieldValue("categoryId", event.target.value);
  };

  const onChangeHandler = async (e) => {
    formik.handleChange(e);
    const { value, maxLength } = e.target;
    let data = {};
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        value
      ) ||
      /^[0-9]{10}$/.test(value)
    ) {
      if (
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          value
        )
      ) {
        data = await axios.get(`${serverApi}/vendorDetailsByMobile`, {
          params: { email: value },
        });
      } else if (/^[0-9]{10}$/.test(value)) {
        data = await axios.get(`${serverApi}/vendorDetailsByMobile`, {
          params: { mobile_number: value },
        });
      }
    } else {
      formik.setErrors({ mobile: "Enter Proper Mobile/Email" });
    }
    setVendor(data.data);
    formik.setFieldValue("name", data?.data?.restaurantName || "");
  };

  const [ShowAddIssue, setShowAddIssue] = useState(false);

  const handleShowAddIssue = () => {
    setShowAddIssue(true);
  };

  const handleCloseAddIssue = () => {
    setShowAddIssue(false);
  };

  const onSuccessAddIssueSuggestion = () => {
    setState({
      ...state,
      category: "",
      mobile: "",
      restaurant: "",
      state: "",
      restaurant_pictures: [],
      restaurant_pictures_new: [],
      combined: "",
    });
    formik.resetForm();
    handleCloseAddIssue();
    props.appendSuggestionNew();
  };

  const onErrorAddSuggestion = () => {
    handleCloseAddIssue();
  };

  const formik = useFormik({
    initialValues: {
      country: "",
      city: "",
      mobile: "",
      name: "",
      title: "",
      type: "ISSUE",
      categoryId: "",
      description: "",
      attachment: [],
      status: 0,
    },
    validationSchema,
    onSubmit: (values) => {
      const token = props.auth.user.accessToken;
      const formData = {};
      formData.issue_title = values.title;
      formData.category = values.categoryId;
      formData.comment = values.description;
      formData.attachment = state.restaurant_pictures;
      formData.thumbnails = state.thumbnailImages;
      formData.status = 0;
      formData.type = values.type;
      formData.restaurant_id = vendor?.restaurantId;
      dispatch(
        addIssuesSuggestionAdmin(
          token,
          formData,
          onSuccessAddIssueSuggestion,
          onErrorAddSuggestion
        )
      );
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  const [category, setCategory] = useState([]);
  // const onSuccessGetFavChain = (data) => {
  //   var cateogryIcons = [];
  //   for (var i = 0; i < data.length; i++) {
  //     cateogryIcons.push({ name: data[i].title, id: data[i]._id });
  //   }
  //   setCategory(cateogryIcons);
  // };

  useEffect(() => {
    if (!isEmpty(props.category)) {
      setCategory(props.category);
    }
  }, [props.category]);

  useEffect(() => {
    // props.getAllCateogryForIcons(onSuccessGetFavChain);
    formik.setFieldValue("title", "");
    setState({ ...state, isLoading: true, errors: {} });
    axios
      .get("https://ipapi.co/json")
      .then((result) => {
        setState({
          ...state,
          country_code: result.data.country_calling_code,
          country: result.data.country_code,
          isLoading: false,
        });
        // formik.setFieldValue("code", result.data.country_calling_code);
      })
      .catch((error) =>
        setState({
          ...state,
          error,
          isLoading: false,
        })
      );
  }, []);
  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.title) {
      let titleElement = document.getElementById("title");
      titleElement.focus();
    } else if (formik.errors && formik.errors.categoryId) {
      let catElement = document.getElementById("categoryId");
      catElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descDateElement = document.getElementById("description");
      descDateElement.focus();
    }
  }, [count]);

  const [type, setType] = useState("ISSUE");

  const handleChangeCode = (event) => {
    formik.setFieldValue("code", event.target.value);
  };

  return (
    <React.Fragment>
      <Button
        variant="danger"
        className="btn2 btn-lg"
        onClick={handleShowAddIssue}
      >
        {props.actionBy === "addIssue"
          ? "+ Add Issues/Suggestion"
          : "+ Add Suggestion"}
      </Button>
      <Modal
        show={ShowAddIssue}
        onHide={handleCloseAddIssue}
        centered
        size="md"
      >
        <Modal.Header className="border-0 pb-0" closeButton>
          <Modal.Title className="f22-500">
            {props.actionBy === "addIssue"
              ? "Add Issues/Suggestion"
              : "Suggest New"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              {/* <Col lg={12}>
                <Form.Group>
                  <span id="country">
                    <NewSelectBoxInput
                      selectLabel="Country"
                      name="country"
                      value={state.country}
                      onChange={selecthandleChange}
                      getCountries={getCountries}
                      en={en}
                    />
                  </span>
                  {formik.errors.country && formik.touched.country ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.country}
                    </div>
                  ) : null}
                </Form.Group>
              </Col> */}
              <Col lg={12}>
                <Row>
                  <Col xs={5} className="pr-0">
                    <FormControl variant="outlined" className="w-100">
                      <TextField
                        id="mobile"
                        label="Mobile/Email"
                        type="text"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.mobile && formik.touched.mobile
                            ? "enError"
                            : ""
                        }`}
                        name="mobile"
                        onChange={onChangeHandler}
                        inputProps={{ maxLength: 60 }}
                        value={formik.values.mobile}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.mobile && formik.touched.mobile ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.mobile}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col xs={7}>
                    <Form.Group>
                      <TextField
                        id="name"
                        label="Restaurant Name"
                        type="text"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.name && formik.touched.name
                            ? "enError"
                            : ""
                        }`}
                        name="name"
                        onChange={formik.handleChange}
                        onKeyDown={InputCharacterCheck}
                        inputProps={{ maxLength: 60 }}
                        value={formik.values.name}
                        onBlur={formik.handleBlur}
                        disabled
                      />
                      {formik.errors.name && formik.touched.name ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.name}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col lg={12}>
                <Form.Group>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-Select Restaurant">
                      Type
                    </InputLabel>
                    <Select
                      id="type"
                      value={formik.values.type}
                      onChange={formik.handleChange}
                      label="Select Type"
                      inputProps={{
                        name: "type",
                        id: "outlined-restaurant",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value={"ISSUE"}>Issues</option>
                      <option value={"SUGGESTION"}>Suggestions</option>
                    </Select>
                    {formik.errors.type && formik.touched.type ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.type}
                      </div>
                    ) : null}
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <TextField
                    id="title"
                    variant="outlined"
                    label="Title"
                    name="title"
                    className={`w-100  ${
                      formik.errors.title && formik.touched.title
                        ? "enError"
                        : ""
                    }`}
                    onChange={formik.handleChange}
                    value={formik.values.title}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.title && formik.touched.title}
                  />
                  {formik.errors.title && formik.touched.title ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.title}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-Category">
                      Category
                    </InputLabel>
                    <Select
                      id="categoryId"
                      value={state.category}
                      onChange={handleChangeCategoryAdd}
                      label="Category"
                      inputProps={{
                        name: "category",
                        id: "outlined-Category",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {category.map((item, index) => (
                        <option label={item.name} value={item.id} key={index}>
                          {item.name}
                        </option>
                      ))}
                    </Select>
                    {formik.errors.categoryId && formik.touched.categoryId ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.categoryId}
                      </div>
                    ) : null}
                  </FormControl>
                </Form.Group>
                <Form.Group>
                  <TextField
                    id="description"
                    variant="outlined"
                    label="Description"
                    multiline
                    rows="5"
                    name="description"
                    className={`w-100  ${
                      formik.errors.description && formik.touched.description
                        ? "enError"
                        : ""
                    }`}
                    onChange={formik.handleChange}
                    value={formik.values.description}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.errors.description && formik.touched.description
                    }
                  />
                  {formik.errors.description && formik.touched.description ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
              {formik.values.type === "ISSUE" && (
                <Col md={12}>
                  <SimpleReactLightbox>
                    <MultipleImageUploadComponent
                      title="Add Photos"
                      onChange={uploadMultipleFiles}
                      stateValue={
                        state.restaurant_pictures && state.restaurant_pictures
                      }
                      newUploaded={
                        state.restaurant_pictures_new
                          ? state.restaurant_pictures_new
                          : []
                      }
                      combined={state.combined}
                      onCompleteUploadMultipleCrop={
                        onCompleteUploadMultipleCrop
                      }
                      thumbnail={state.thumbnail}
                      removeImage={multipleResetFile}
                      accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                      cancelFiles={cancelFiles}
                    />
                    <div className="font_12_r c_gray mb-4 d-flex">
                      (You can upload maximum 5 pic per issue 700 x 420 pixels)
                    </div>
                  </SimpleReactLightbox>
                </Col>
              )}
              <Col md={12}>
                <div className="pt-4 d-flex align-items-center">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5 "
                    onClick={handleCloseAddIssue}
                  >
                    Back
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => onClickSave()}
                    className="btn150px btn-lg px-5"
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

AddOpenIssuesVendor.propTypes = {
  auth: PropTypes.object.isRequired,
  getCityFromCountry: PropTypes.func.isRequired,
  getRestaurantByCityName: PropTypes.func.isRequired,
  getAllCateogryForIcons: PropTypes.func.isRequired,
  addNewSuggestionAdmin: PropTypes.func.isRequired,
  addNewIssuesAdmin: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allSuggestions: state.commonSuperAdmin.allSuggestions,
  onboarding: state.onboarding && state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  getCityFromCountry,
  getRestaurantByCityName,
})(AddOpenIssuesVendor);
